import { ReactNode } from "react";

import { DesignToken, Heading, RadiusToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

interface IIntegrationCardProps {
  icon?: ReactNode;
  title: string;
  titleBadge?: ReactNode;
  description: string;
  rightNodes?: ReactNode;
}

export const IntegrationCard: React.FC<IIntegrationCardProps> = ({
  icon,
  title,
  titleBadge,
  description,
  rightNodes,
}) => {
  return (
    <Flex
      padding={withVar(SpacingToken.Spacing4)}
      border={`1px solid ${withVar(DesignToken.BorderBasicSecondary)}`}
      borderRadius={withVar(RadiusToken.Radius3)}
      gap={withVar(SpacingToken.Spacing4)}
    >
      {icon}
      <Flex column gap={withVar(SpacingToken.Spacing1)}>
        <Flex alignItems="center" gap={withVar(SpacingToken.Spacing2)}>
          <Heading size="xs">{title}</Heading>
          {titleBadge}
        </Flex>
        <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>{description}</Text>
      </Flex>
      <Flex marginLeft="auto" alignItems="center" gap={withVar(SpacingToken.Spacing4)}>
        {rightNodes}
      </Flex>
    </Flex>
  );
};
